import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className={`ri-search-eye-line text-2xl ${scrolled ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span className={`text-lg font-semibold font-heading ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              {t('siteName')}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/')
                  ? scrolled ? 'text-primary-500' : 'text-background-50'
                  : scrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              {t('navHome')}
            </Link>
            <Link
              to="/category/quanxin"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? scrolled ? 'text-primary-500' : 'text-background-50'
                  : scrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              {t('navCategories')}
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? scrolled ? 'text-primary-500' : 'text-background-50'
                  : scrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              {t('navAbout')}
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-8 h-8 flex items-center justify-center ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}
            aria-label="菜单"
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-3">
            <Link to="/" className={`text-sm font-medium py-2 ${isActive('/') ? 'text-primary-500' : 'text-foreground-700'}`}>
              {t('navHome')}
            </Link>
            <Link to="/category/quanxin" className={`text-sm font-medium py-2 ${location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-700'}`}>
              {t('navCategories')}
            </Link>
            <Link to="/about" className={`text-sm font-medium py-2 ${isActive('/about') ? 'text-primary-500' : 'text-foreground-700'}`}>
              {t('navAbout')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}